import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subscriptionId: 0,
  subscriptionStatus: "pending",
  isPending: false,
  isVerified: false,
  subCommunityId: 0,
};

export const SubscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    subscriptionHandler: (state, action) => {
      state.subscriptionId = action.payload.subscriptionId;
      state.subscriptionStatus = action.payload.subscriptionStatus;
      state.subCommunityId = action.payload.communityId;
    },
    startPolling(state) {
      state.isPending = true;
      state.isVerified = false;
    },
    stopPolling(state) {
      state.isPending = false;
      state.isVerified = true;
    },
    canceledPolling(state) {
      state.isPending = false;
      state.isVerified = false;
    },
  },
});

export const { subscriptionHandler, startPolling, stopPolling, canceledPolling } = SubscriptionSlice.actions;
export default SubscriptionSlice.reducer;
